import React, { createRef } from "react";
import styled from "styled-components";
import { goodpageText } from "../../Lang/fa/Goodpage";
import { PostData } from "../Functions/SendingData";
import { insertError } from "../StakcableError";
import MesQue from '../../assets/newSvg/message-question';
import { Dialog } from "@material-ui/core";
import close from '../../assets/newSvg/close-circle.svg';
import { TextInputWTitle } from "../NewComp/SmallComps/TextInputWTitle";
import { Loading } from "../../components/Loading.js";
import { NotFindContent } from "../Functions/NotFindContent";



const Styles = styled.div`
    display: grid;
    grid-template-columns: 23% 75%;
    grid-gap: 2%;
    height: 100%;
    overflow-y: auto;
    position: relative;

    .bord{
        background: var(--body-2);
        border-radius: var(--border-radius-9);
        padding: 1.5rem;
        width: calc(100% - 3rem);
        height: 6rem;
        color:var(--text-2);
        .question_text{
            font-size: 0.75rem;
            font-weight: 600;
            color: var(--gray-4);
        }
        .add{
            border-radius: var(--border-radius-2);
            padding: 0.8rem 1.5rem;
            color: var(--primary-5);
            border: 1px solid var(--primary-5);
            display: flex;
            justify-content: center;
            position: relative;
            width: calc(100% - 3rem);
            cursor: pointer;
            font-size:1rem;
            font-weight: 500;
            text-decoration: none;
            margin-top: 1rem;
        }
        .dis{
            cursor: default;
            opacity: 0.5;
        }
    }
    .question{
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: flex-start;
        position: relative;
        .more-btn{
            color: var(--primary-8);
            border: var(--border-style-6);
            border-radius: var(--border-radius-9);
            padding: 0.8rem 1rem;
            width: 20%;
            text-align: center;
            font-size: 0.87rem;
            margin: auto;
            font-weight: 700;
            background: rgba(3, 130, 160, 0.10);
        }
        .ques{
            background: var(--body-2);
            border-radius: var(--border-radius-9);
            display: flex;
            flex-direction: column;
            padding: 1.5rem ;
            width: calc(100% - 3rem);
            margin-bottom: 0.75rem; 
            .question-user{
                font-size: 0.87rem;
                font-weight: 600;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                padding: 0.5rem 0;
                .svg{
                    width: 1.5rem;
                    margin-left: 0.2rem;
                    fill: var(--gray-17)
                }
            }
            .answer{
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                margin: 0.5rem  0 ;
                .answer-user{
                    font-size: 0.87rem;
                    font-weight: 600;
                    color: var(--gray-6)
                }
                .answer-date{
                    display: flex;
                    justify-content: flex-end;
                    font-size: var(--fs-good-page-comment-text);
                    font-weight: 500;
                }
                :last-child{
                    border-bottom: none;
                }
            }
        
            .answerQ{

                display: flex;
                flex-direction: row;
                .inputAnswer{
                    width: 50%;
                    outline: var(--primary-2);
                    padding: 0.5rem;
                    border-radius: var(--border-radius-2);
                    border: 1px solid var(--primary-2);
                    font-size: var(--fs-good-page-comment-text);
                }
                input[type="checkbox"]{
                     width: 1.2em;
                    height: 1.2em;
                    background-color: white;
                    vertical-align: middle;
                    border: 1px solid var(--border-color);
                    appearance: none;
                    -webkit-appearance: none;
                    align-items: center;
                    display: flex;
                    margin: auto 0.5rem;
                    cursor: pointer;
                }
                input[type="checkbox"]:checked {
                    background-color: var(--body-2);
                }
                input[type="checkbox"]:checked:after {
                    content: "";
                    background-color: var(--primary-2);
                    width: 0.8em;
                    height: 0.8em;
                    display: flex;
                    margin: 0.12rem;
                }   
                label{
                    display: flex;
                    justify-content: flex-start;;
                    align-items: center;
                    font-size: var(--fs-good-page-comment-text);
                    font-weight: 500;
                }
                .ansRow{
                    display: flex;
                    flex-direction: row;
                    margin: 0.5rem 0;
                    justify-content: flex-start;;
                    font-size: var(--fs-good-page-comment-text);
                    font-weight: 500;;
                    width: 30%;
                    .addAnswer{
                        width: 50%;
                        margin-right: 5%;
                    }
                    .cancelA{
                        width:45%
                    }
                }
            }
            .answer-q{
                padding: 1rem 1.5rem 0;
                display: flex;
                justify-content: right;
                border-top: var(--border-style-2);
                cursor: pointer;
                text-align: right;
                color: var(--primary-8);
                font-size: 0.87rem;
                font-weight: 600;
            }
            .dis{
                cursor: default;
                opacity: 0.5;
            }
            .cancelA{
                background: none;
                color: var(--secondry-1);
                border:1px solid var(--secondry-1);
                width: 5%;
                margin-left: 0;
            }
        }
    }
    @media screen and (max-width:850px){
        display: flex;
        flex-direction: column;
        width: 100%;
        .bord{   
            padding: 1rem 1.5rem;
            position: relative;
            height: auto;
        }
        .question{
            margin: 0.75rem 0;     
            .more-btn{
                width: 50%;
            }       
            .ques{
                padding-bottom: 0;
                .question-user{
                    width: 100%
                }
    
                .answer-q{
                    margin-left: 0;
                    margin-bottom: 1rem;
                }
                
            }
        }
    }
`;
const StylesQu = styled.div`
    background-color:var(--body-2);
    border-radius: var(--border-radius);
    padding: 1.5rem 0;
    display: flex;
    width: 100%;
    flex-direction: column;
    color: var(--text-5);
    .top-pop{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
        padding: 0 1.5rem 1rem;
        border-bottom: var(--border-style-2);
        .title{
            font-size: 1rem;
            font-weight: 400;
            text-align:start;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            .text{
                font-size: 0.75rem;
                font-weight: 600;
                color: var(--gray-6);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 20rem;
                margin-top: 0.2rem;
            }
        }
        .close{
            cursor: pointer;
        }
    }
    .inputAnswer{
        padding: 1rem 1.5rem;
    }
    .ansRow{
        padding:0.5rem 1.5rem 0;
        width: calc(100%  - 3rem);
        display: flex;
        flex-direction: row;
        position: relative;
        .unknown{
            width: 1rem;
        }
        .addAnswer{
            padding: 1rem 1.5rem ;
            width: calc(100% - 3rem);
            display: flex;
            justify-content: center;
            align-items: center;
            border: none;
            border-radius: var(--border-radius-9 );
            cursor: pointer;
            text-align: center;
            color: var(--text-3);
            background-color: var(--primary-5);
        }
        input[type="checkbox"]{
            width: 1.2em;
            height: 1.2em;
            background-color: white;
            vertical-align: middle;
            border: 1px solid var(--border-color);
            appearance: none;
            -webkit-appearance: none;
            align-items: center;
            display: flex;
            margin: auto 0.5rem;
            cursor: pointer;
        }
        input[type="checkbox"]:checked {
            background-color: var(--body-2);
        }
        input[type="checkbox"]:checked:after {
            content: "";
            background-color: var(--primary-2);
            width: 0.8em;
            height: 0.8em;
            display: flex;
            margin: 0.12rem;
        }   
    }
    @media screen and (max-width:850px) {
        .top-pop{
            .title{
                .text{
                    width: 10rem;
                }
            }
        }
    }
`


class GoodQuestions extends React.Component {
    constructor(props) {
        super(props);
        this.addref = createRef()
        this.state = {
            user:JSON.parse(localStorage.getItem("userdata")),
            objectData:[],
            objectData2:[],
            inpiuTxt:'',
            unknown:false,
            add:'',
            refrence:'',
            show:false,
            partCom: 3,
        };
    }
    componentDidMount () {
        this.setState({
            question: '',
        });
        this.getData();
    }
    //get all questions
    getData = () => {
        let formData = new FormData();
        formData.append("G_CODE", this.props.code);
        formData.append("U_G_COMM_CONTROL", 1);
        this.setState({
            inpiuTxt: '',
            sending: true
        });
        PostData(
            process.env.REACT_APP_API + "/api/v1/goods/user_goods_comment/select_by_g_code",
            formData,
            this,
            this.Proccess
        );
    }
    Proccess(obj, data){
        let response = JSON.parse(data);
        if (response.status === 'success') {    
            obj.setState({
                response: 'success',
                length: response.question.length,
                objectData: response.question,
                objectData2: response.question.slice(0 , 3),
                sending: false,
                inpiuTxt:''
            });
        } else if (response.status === 'error') {
            obj.setState({
                response: 'success',
                sending: false
            });
        } else if (response.status === 'error-no-internet') {
            obj.setState({
                sending: false
            });
        }
    }
    //send new question
    SendQuestion=()=>{
        if(this.state.inpiuTxt !== ''){
            let formData = new FormData();
            formData.append("api_token", this.state.user.token);
            formData.append("U_CODE", this.state.user.usercode);
            formData.append("SH_G_CODE", ( this.props.shgcode ?? -1));
            formData.append("G_CODE", this.props.code);
            formData.append("U_LNAME", this.state.user.U_LNAME);
            formData.append("U_G_COMM_DESC", this.state.inpiuTxt);
            formData.append("U_G_COMM_USER_VIEW", this.state.unknown ? 0 : 1);
            formData.append("U_G_COMM_USER_RECOMMAND",1);
            formData.append("U_G_COMM_TYPE", 1);
            this.setState({
                sending: true,
            });
            PostData(
            process.env.REACT_APP_API + "/api/v1/goods/user_goods_comment/insert",
            formData,
            this,
            this.SendProccess
            );
        }else{
            return
        }
    }
    SendProccess(obj, data){
        let response = JSON.parse(data);
        if (response.status === 'success') {    
            obj.setState({
                response2: 'success',
                sending2: false, 
                unknown:false,
                inpiuTxt: '',
            });
            insertError('سوال شما پس از تایید کارشناس نمایش داده خواهد شد' ,'green' , 3000)
            obj.getData()
            obj.close()
        } else if (response.status === 'error') {
            obj.setState({
                response2: 'success',
                sending2: false,
                inpiuTxt: '',
            });
        } else if (response.status === 'error-no-internet') {
            obj.setState({
                sending2: false,
                inpiuTxt: '',
            });
        }
    }
    //answer a question
    answerQuestion=()=>{
        if(this.state.inpiuTxt !== ''){
            let formData = new FormData();
            formData.append("api_token", this.state.user.token);
            formData.append("U_CODE", this.state.user.usercode);
            formData.append("SH_G_CODE", this.props.shgcode ?? -1);
            formData.append("G_CODE", this.props.code);
            formData.append("U_LNAME", this.state.user.U_LNAME);
            formData.append("U_G_COMM_DESC", this.state.inpiuTxt);
            formData.append("U_G_COMM_USER_VIEW", this.state.unknown ? 0 : 1);
            formData.append("U_G_COMM_USER_RECOMMAND",1);
            formData.append("U_G_COMM_REFRENCE",parseInt(this.state.refrence));
            formData.append("U_G_COMM_TYPE", 2);
            this.setState({
                sending: true,
            });
            PostData(
            process.env.REACT_APP_API + "/api/v1/goods/user_goods_comment/reply",
            formData,
            this,
            this.SendAnswer
            );
        }else{
            return 
        }
    }
    SendAnswer(obj, data){
        let response = JSON.parse(data);
        if (response.status === 'success') {    
            obj.setState({
                response3: 'success',
                sending3: false, 
                unknown:false,
                inpiuTxt:'',
                add:''
            });
            insertError('پاسخ شما پس از تایید کارشناس نمایش داده خواهد شد' ,'green' , 6000)
            obj.getData()
            obj.close()
        } else if (response.status === 'error') {
            obj.setState({
                response3: 'error',
                sending3: false
            });
        } else if (response.status === 'error-no-internet') {
            obj.setState({
                sending3: false
            });
        }
    }

    //more btn
    showMore = () => {
        if(this.state.partCom < this.state.length){
            let newCom = this.state.partCom + 3
            this.setState({
                partCom:newCom,
                objectData2 : this.state.objectData.slice(0 , newCom)
            })
        }
    }

    //handel send data
    handelSend=()=>{
        if(this.state.allow === 'reply'){
            this.answerQuestion()
        }else{
            this.SendQuestion()
        }
    }
    //scroll window
    scrolltop=()=>{
        if(window.innerWidth > 850){
            return 1300;
        }else{
            return 850
        }
    }
    addNew=()=>{
        window.scrollTo({
            top: this.addref.current.offsetTop +  this.scrolltop(),
            behavior:"smooth"
        })
    }
    //fill input 
    fillText=(e)=>{
        this.setState({
            inpiuTxt: e.target.value,
            // refrence : e.target.dataset.id
        })
    }
    //user limit
    userknwn=()=>{
        if(this.state.unknown){
            this.setState({
                unknown : 0
            })
        }else{
            this.setState({
                unknown : 1
            })
        }
    }
    //open popup
    btnShow=(name,index ,e ,text)=>{
        if(this.props.userdata){
            if(name === 'new'){
                this.setState({
                    show:true,
                    allow:name
                })
            }else{
                if(this.state.add === index){
                    this.setState({
                        add:'',
                    })
                }else{
                    this.setState({
                        add: index,
                        refrence : e.target.dataset.id,
                        show:true,
                        allow:name,
                        text: text
                    })
                }
            }
        }else{
            insertError('برای ثبت پرسش/پاسخ لطفا وارد حساب کاربری خود شوید', 'red', 5000)
        }
    }
    //close popup
    close=()=>{
        this.setState({
            show :false,
            text:''
        })
    }
    //popup field
    showPop=()=>{
        let Tit = goodpageText.questionText 
        let lab = goodpageText.questext 
        let Text = goodpageText.userUnkownq
        let btn = goodpageText.qdone
        if(this.state.allow === 'reply'){
            Tit = goodpageText.replyText 
            lab = goodpageText.anstext 
            Text = goodpageText.userUnkowna
            btn = goodpageText.adone
        }
        if(this.state.show){
            return (
                <Dialog
                    fullWidth={true}
                    maxWidth={'xs'}
                    open={this.state.show}
                    onClose={''}
                    style={{backgroundColor: 'rgba(0,0,0,0.5)'}}
                >
                    <StylesQu >
                        <div className="top-pop">
                            <div className="title">
                                {Tit}
                                {this.state.text ? <span className="text">{this.state.text}{this.state.text}{this.state.text}{this.state.text}{this.state.text}{this.state.text}{this.state.text}{this.state.text}{this.state.text}{this.state.text}{this.state.text}</span> :''}
                            </div>
                            <img alt='close' src={close} className="close" onClick={this.close}/>
                        </div>
                        <div className="inputAnswer">
                            <TextInputWTitle
                                error='' 
                                defaultValue={this.state.inpiuTxt} 
                                title={lab} 
                                onchange={this.fillText} 
                            />

                        </div>
                        <div className="ansRow">
                            <input type='checkbox' className='unknown' checked={this.state.unknown} id='unknown' onChange={this.userknwn}/>   
                            <label htmlFor="unknown">{Text}</label>
                        </div>
                        <div className="ansRow">
                            <div className="addAnswer" style={{ opacity: (this.state.inpiuTxt !== '' ? '' :'0.5') , cursor:(this.state.inpiuTxt !== '' ? '' :'none') }} onClick={this.handelSend}>{btn}</div>
                        </div>
                    </StylesQu>
                </Dialog>
            )
        }
        return
    }
    //rigth board of popup
    rightbroad=()=>{
        return(
            <div className="bord">
                <span className="question_text">شماهم درباره این کالا پرسش ثبت کنید</span>
                <div onClick={()=>this.btnShow('new')} className={'add '+ (this.props.userdata ? '' : 'dis')} >ثبت پرسش</div>
            </div>
        )
    }
    //shop or user name show
    handelDesc=(value)=>{
        let val = value.U_G_COMM_DESC
        let name =''
        let inval = val.split(' ')
        if(inval[0] === 'shop'){
            inval.splice(0,1)
            name= inval.join(' ')
            return name
        }else{
            // name = value.U_G_COMM_USER_VIEW ? (value.FULL_NAME + ': ') : 'ناشناس : '
            name = 'پاسخ : '
            return name + ' ' +val
        }
    }
    //list of answer
    everyAnswer=(answers)=>{
        let answer = answers.map((ans, index) => {
            return(
                <div className="answer" key={index}>
                    <div className="answer-user">{this.handelDesc(ans)}</div>
                </div>
            )
        })
        return answer
    }
    //list of questions
    everyquestion=()=>{
        if(this.state.length){
            let temp = this.state.objectData2
            let question = temp.map((que , index)=>{
                return(
                    <div className="ques" key={index}>
                        <div className="question-user">
                            <MesQue cls={"svg"}/>
                            {que.U_G_COMM_DESC}
                        </div>
                        {this.everyAnswer(que.ANSWERS)}
                        <div className="answer-q" data-id={que.U_G_COMM_SERIAL} onClick={(e)=>this.btnShow('reply',index,e ,que.U_G_COMM_DESC)}> ثبت پاسخ</div>
                    </div>
                )
            })
            return question

        }else{
            return <div className="empty"><NotFindContent text={goodpageText.notfind} /></div>
        }
    }
    //list or loading
    questionbord=()=>{
        if(this.state.objectData){
            return(
                <div className='question'>
                    {this.everyquestion()}
                    {
                        this.state.length > this.state.partCom ? (
                            <div className="more-btn" onClick={this.showMore} >{goodpageText.more}</div>
                        ):''
                    }
                    
                </div>
            )
        }
        return <Loading/>
    }
    
    render() {
        return (
            <Styles ref={this.addref}>
                {this.rightbroad()}
                {this.questionbord()}
                {this.showPop()}
            </Styles>
        );
    }
}

export default GoodQuestions;
